











































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { CV, GetCVRequest, ValidColorTheme } from '@app/componentlib/common/types/CVTypes'
import Avatar from '@app/componentLib/src/views/components/Avatar.vue'
import CvStyling from './cv-sections/CvStyling.vue'
import CvDownload from './cv-sections/CvDownload.vue'
import CvAdjust from './cv-sections/CvAdjust.vue'
import PdfViewer from '../components/PdfViewer.vue'
import PdfSlider from '@app/componentLib/src/views/components/PdfSlider.vue'
import BaseIcon from '../components/BaseIcon.vue'
import PDFFile from '../components/icons/PDFFile.vue'
import WordFile from '../components/icons/WordFile.vue'
import { Option } from '@app/componentlib/common/types/BootstrapTypes'
import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import { ProfileData } from '@app/componentlib/src/common/types/profileTypes'
import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ga } from '@app/componentlib/src/application/analytics'

export interface Section {
    path: string
    text: string
    id: number
    steps?: number
    current?: boolean
}

@Component<CvView>({
  props: {
    langOptions: Array,
    url: String,
    siteLanguage: String,
    competencesLink: String,
    linkToDocuments: String,
    documentsLinkName: String
  },
  components: {
    Avatar,
    CvStyling,
    CvAdjust,
    CvDownload,
    PdfViewer,
    PdfSlider,
    BaseIcon,
    PDFFile,
    WordFile
  },
  watch: {

  }
})

export default class CvView extends Vue {
  /**
   * Props variables
   */
  langOptions: Option[] | undefined
  url: string | undefined
  competencesLink: string | undefined
  linkToDocuments: string | undefined
  documentsLinkName: string | undefined

  /**
   * Component state variables
   */
  sections: Section[] = [
    { path: '1', text: this.t.CV_Tool_Menu_Template, id: 1, steps: 1, current: false },
    { path: '2', text: this.t.CV_Tool_Content_Styling, id: 2, steps: 1, current: false },
    { path: '3', text: this.t.CV_Tool_Menu_Adjust_Information, id: 3, steps: 1, current: false },
    { path: '4', text: this.t.CV_Tool_Menu_Download, id: 4, steps: 1, current: false }
  ]
  currentSection: Section | null = null
  startPath = '2'
  selectedProfileId: number | null = null
  showPreview = false
  startFromLast: boolean = false
  previewBtnText = this.t.CV_Tool_Show_Preview
  savedToDocuments: boolean = false
  savedCoverLetterToDocuments: boolean = false

  counter = 0

  /**
   * Lifecycle
   */
  beforeMount() {
    let path = localStorage.getItem('cvSectionPath')
    if(path !== null && path !== this.startPath) {
      this.startPath = path
    }
    this.changeSection({})
  }

  async mounted () {
    if(this.selected !== undefined) {
      console.log('CvView: Selected CV: ', this.selected)
      this.selectedProfileId = await CvModule.selectedProfileId
      //Find colortheme for the selected CV if we dont have a colortheme
      if(this.defaultColor !== undefined && this.colorTheme === undefined) await CvModule.changeColor(this.defaultColor.id)
    }
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get previewUrl (): string | undefined {
    if(this.selected !== undefined) {
      const cvLang = this.cvId ? this.cvId.lang : undefined
      const selectedProfileId = CvModule.selectedProfileId ? CvModule.selectedProfileId : undefined
      const req: GetCVRequest = {
        mediaId: this.selected.mediaId,
        colorNodeId: this.colorTheme,
        langCode: cvLang,
        template: this.selected.template,
        helptextNodeId: CvModule.helpTextId,
        profileNodeId: selectedProfileId,
        pdf: true,
        Counter: this.counter,
        UseMotivationalTexts: CvModule.useMotivationalTexts,
        isPreview: true
      }

      // The two texts are only used to help previewUrl update when they change in cvdata.
      const motivationalTexts = {
        'MotivationalHeadline': this.motivationalHeadline,
        'MotivationalText': this.motivationalText
      }

      //This check is to prevent templates without colortheme to be implemented (As templates needs a default colortheme)
      if (this.selected.template === true && this.colorTheme !== undefined || this.selected.template === false) {
        if (CvModule.useMotivationalTexts === true) {
          CvModule.setCVPreview(req)
          this.counter++
        } else {
          CvModule.setCVPreview(req)
        }
      }

      return CvModule.previewUrl
    }
    return undefined
  }
  get helpText () {
    return CvModule.helpTextId
  }
  get langCode () {
    return CvModule.cvId?.lang
  }
  get cvId () {
    return CvModule.cvId
  }
  get colorTheme () {
    return CvModule.colorTheme
  }
  get profileData (): ProfileData | undefined {
    return ProfileModule.profileData
  }
  get defaultColor (): ValidColorTheme | undefined {
    if(this.selected !== undefined && this.selected.validColorThemes !== null) {
      return this.selected.validColorThemes.find((ct: ValidColorTheme) => ct.default === true)
    }
    return undefined
  }

  get selected (): CV | undefined {
    return CvModule.selectedCv
  }

  isActiveNav (path: string) {
    const activePath = path === this.currentSection?.path
    return activePath
  }

  get profileLink (): string | undefined {
    return AppModule.portalSettings.profileLink
  }

  get savingToDocuments (): boolean  {
    if (CvModule.savingToDocuments) {
      this.savedToDocuments = true
    }
    return CvModule.savingToDocuments
  }
  get savingCoverLetterToDocuments (): boolean  {
    if (CvModule.savingCoverLetterToDocuments){
      this.savedCoverLetterToDocuments = true
    }
    return CvModule.savingCoverLetterToDocuments
  }

  get motivationalHeadline (): string {
    return CvModule.motivationalHeadline
  }

  get motivationalText (): string {
    return CvModule.motivationalText
  }

  /**
   * Methods
   */
  clearSelection (where?: string) {
    //Clear selected item
    if(where !== undefined) {
      ga.event({
        action: 'Clear selection',
        category: 'CV Tool',
        label: where
      })
    }
    this.$emit('clearSelect')
  }

  downloadCV (pdf: boolean, dropdown: boolean) {
    console.log('downloadCV of this data:', this.selected)
    if(this.selected !== undefined) {
      const selectedProfileId = CvModule.selectedProfileId ? CvModule.selectedProfileId : undefined
      let request: GetCVRequest = {
        langCode: CvModule.langCode,
        mediaId: this.selected.mediaId,
        template: this.selected.template,
        pdf: pdf,
        profileNodeId: selectedProfileId,
        colorNodeId: this.colorTheme,
        helptextNodeId: CvModule.helpTextId
      }
      if(this.selected.template === true && this.colorTheme === undefined) {
        const colorTheme = this.defaultColor
        if(colorTheme !== undefined) {
          CvModule.changeColor(colorTheme.id)
          request.colorNodeId = colorTheme.id
        }
      }
      CvModule.getCV(request)
      ga.event({
        action: `CV Download - ${dropdown === true ? 'dropdown' : 'page'}`,
        category: 'CV Tool',
        label: `${selectedProfileId} ${pdf === true ? 'PDF' : 'WORD'}`,
      })
    }
  }

  downloadCoverLetter() {
    if (this.selected !== undefined) {
      let request: GetCVRequest = {
          langCode: CvModule.langCode,
          mediaId: this.selected.coverLetterId,
          colorNodeId: this.colorTheme,
        }
        if (this.selected.template === true && this.colorTheme === undefined) {
        const colorTheme = this.defaultColor
        if (colorTheme !== undefined) {
          CvModule.changeColor(colorTheme.id)
          request.colorNodeId = colorTheme.id
        }
      }
      CvModule.getCoverLetter(request)
      ga.event({
        action: `Cover Letter Download`,
        category: 'CV Tool',
        label: 'WORD',
      })
    }
  }

  saveCoverLetterInDocuments() {
    if(this.selected !== undefined) {
      const request: GetCVRequest = {
        langCode: CvModule.langCode,
        mediaId: this.selected.coverLetterId,
        colorNodeId: this.colorTheme,
      }
      CvModule.saveCoverLetterToDocuments(request)
      ga.event({
        action: `Cover Letter Save In Documents`,
        category: 'CV Tool',
        label: 'WORD'
      })
    }
  }

  changeSection(options:{path?: string, back?: boolean, navBar?: boolean}) {
    var path = options ? options.path : undefined
    var back = options ? options.back : undefined
    //No path? Set it to default for view which is 2
    if(path === undefined) {
      path = this.startPath
    } else {
      let userAction = undefined
      if(path  === '1') {
        //If user clicks back to select template overview - track it toegether with "clear selection"
        //Also track it as a user interaction with the navbar
        userAction = 'Back to select template'
        ga.event({
          action: 'Clear selection',
          category: 'CV Tool',
          label: 'NavBar ' + userAction
        })
      } else {
        userAction = options.navBar ? 'NavBar' : 'Arrows'
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: userAction
        })
      }
    }
    const newPath = path ? path : ''
    this.startFromLast = back ? back : false
    localStorage.setItem('cvSectionPath', newPath)
    location.hash = newPath
    const newSection = this.sections.find(section => section.path === newPath)
    if(newSection !== undefined) {
      this.currentSection = newSection
    }
  }

  saveInDocuments (pdf: boolean, dropdown: boolean) {
    if(this.selected !== undefined) {
      const selectedProfileId = CvModule.selectedProfileId ? CvModule.selectedProfileId : undefined
      const request: GetCVRequest = {
        langCode: CvModule.langCode,
        mediaId: this.selected.mediaId,
        profileNodeId: selectedProfileId,
        pdf: pdf,
        colorNodeId: this.colorTheme,
        helptextNodeId: CvModule.helpTextId
      }
      CvModule.saveToDocuments(request)
      ga.event({
        action: `CV Save In Documents - ${dropdown === true ? 'dropdown' : 'page'}`,
        category: 'CV Tool',
        label: `${selectedProfileId} ${pdf === true ? 'PDF' : 'WORD'}`
      })
    }
  }

  togglePreview () {
    this.showPreview = !this.showPreview
    if(this.showPreview === true) {
      //Text to show when preview is shown
      this.previewBtnText = this.t.CV_Tool_Show_Settings
    } else {
      // Text on button when preview is hidden:
      this.previewBtnText = this.t.CV_Tool_Show_Preview
    }
  }
}
